export const validateEmail = (email) => {
    const regex = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regex.test(String(email));
};

export const validatePhone = (phone) => {
    return (phone.length === 14 || phone.length === 0);
};

export const formatPhoneInput = (phone) => {
    phone = phone.replace(/[^\d]/g, '');

    if (phone.length > 3 && phone.length <= 6) {
        phone = `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    } else if (phone.length > 6) {
        phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
    }

    return phone;
};
